import config from "utils/apiconfig";
import request from "utils/request";

const { api } = config;
const { briefreport, briefreportId } = api;

/**
 * 查询河流列表
 */
export async function briefreportList(params) {
  return request({ url: briefreport, method: "get", data: params });
}

/**
 * 查询河流详情
 */
export async function briefreportDetail(id) {
  return request({
    url: briefreportId,
    method: "get",
    data: {
      damId: id
    }
  });
}
